export interface User {
  name: string;
  firstName: string | null;
  lastName: string | null;
}

/** "Firstname Lastname (username)", or just the username if no full name is known. */
export const formatUserName = ({ name, firstName, lastName }: User) => {
  const fullName = [firstName, lastName].filter(Boolean).join(" ");
  return fullName ? `${fullName} (${name})` : name;
};
